import { render, staticRenderFns } from "./config-general.vue?vue&type=template&id=30441dd8&scoped=true&"
import script from "./config-general.vue?vue&type=script&lang=js&"
export * from "./config-general.vue?vue&type=script&lang=js&"
import style0 from "./config-general.vue?vue&type=style&index=0&id=30441dd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30441dd8",
  null
  
)

export default component.exports